// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section_Section__2FiEL","Content":"Section_Content__3jm9u"};